import NProgress from 'nprogress';

declare global {
    interface Document {
        progressLoader?: typeof NProgress;
    }
}

const progressLoader =
  document.progressLoader =
  document.progressLoader ?? NProgress.configure({ showSpinner: false });

// Use pageshow instead of load to handle back/forward navigation
window.addEventListener('pageshow', function(e) {
    progressLoader.done(true);
    progressLoader.remove();
    sessionStorage.removeItem('nprogress-busy');
});

if (sessionStorage.getItem('nprogress-busy')) {
    progressLoader.start();
    progressLoader.set(0.4);
}

document.addEventListener('click', function (e: MouseEvent) {
    const target = e.target as HTMLElement;
    const link = target.closest('a');
    if (link && link.href && !link.target && link.origin === location.origin) {
        if (!link.href.includes('#') || link.href.split('#')[0] !== location.href.split('#')[0]) {
          sessionStorage.setItem('nprogress-busy', 'true');
          progressLoader.start();
        }
    }
});

// Interceptar formularios
document.addEventListener('submit', function(e) {
    const form = e.target as HTMLFormElement;
    if (!form.target || form.target === '_self') {
        sessionStorage.setItem('nprogress-busy', 'true');
        progressLoader.start();
    }
});
